import { render, staticRenderFns } from "./ConsentBanner.vue?vue&type=template&id=fab53c26&scoped=true"
import script from "./ConsentBanner.vue?vue&type=script&lang=js"
export * from "./ConsentBanner.vue?vue&type=script&lang=js"
import style0 from "./ConsentBanner.vue?vue&type=style&index=0&id=fab53c26&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab53c26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fab53c26')) {
      api.createRecord('fab53c26', component.options)
    } else {
      api.reload('fab53c26', component.options)
    }
    module.hot.accept("./ConsentBanner.vue?vue&type=template&id=fab53c26&scoped=true", function () {
      api.rerender('fab53c26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Configuration/ConsentBanner.vue"
export default component.exports